import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import * as settings from "../../lib/air-api-constant";
import { SubSink } from 'subsink';

@Injectable({
    providedIn: "root", 
})
export class CodedataService {
    constructor(protected http: HttpClient) { }

    getPorts(body: any = {}) {
        return this.http.post(settings.UserEndPoint.FiltersPoints.PORTS, body);
    }

    getPeriods(body: any = {}) {
        return this.http.post(settings.UserEndPoint.FiltersPoints.PERIODS, body);
    }

    getStatus(body: any = {}) {
        return this.http.get<any>(settings.UserEndPoint.FiltersPoints.STATUS, { params: body });
    }

    getCarrierNames(body: any = {}) {
        return this.http.post<any>(settings.UserEndPoint.FiltersPoints.CARRIER_NAMES, body);
    }

    getDrayProviders(body: any = {}) {
        return this.http.post<any>(settings.UserEndPoint.FiltersPoints.DRAY_PROVIDERS, body);
    }

    getContainerTypes(body: any = {}) {
        return this.http.post<any>(settings.UserEndPoint.FiltersPoints.CONTAINER_TYPES, body);
    }

    getShipFromLocations(body: any = {}) {
        return this.http.post<any>(settings.UserEndPoint.FiltersPoints.SHIP_FROM_LOCATIONS, body);
    }

    getDeliveryLocations(body: any = {}) {
        return this.http.post<any>(settings.UserEndPoint.FiltersPoints.DELIVERY_LOCATIONS, body);
    }

    getDateRanges(body: any = {}) {
        return this.http.post<any>(settings.UserEndPoint.FiltersPoints.DATE_RANGES, body);
    }
   
}
